// directives/longpress.js
export default {
    bind(el, binding, vnode) {
      let pressTimer = null;
  
      // 定义开始长按的函数
      const start = (e) => {
        if (e.type === 'click' && e.button !== 0) {
          return;
        }
        if (pressTimer === null) {
          pressTimer = setTimeout(() => {
            handler();
          }, 1000); // 设置长按时间，这里是 1 秒
        }
      };
  
      // 定义取消长按的函数
      const cancel = () => {
        if (pressTimer !== null) {
          clearTimeout(pressTimer);
          pressTimer = null;
        }
      };
  
      // 运行绑定的函数
      const handler = (e) => {
        binding.value(e);
      };
  
      // 添加事件监听器
      el.addEventListener('mousedown', start);
      el.addEventListener('touchstart', start);
  
      // 取消长按的事件监听器
      el.addEventListener('click', cancel);
      el.addEventListener('mouseout', cancel);
      el.addEventListener('touchend', cancel);
      el.addEventListener('touchcancel', cancel);
    },
  };